<template>
  <div>
    <v-icon @click="abrirDialog" size="14" class="cursor-pointer">mdi-pencil</v-icon>

    <SysDialog
      v-model="dialog_ativo"
      titulo="Previsão de gatilho"
      :largura="!apenas_produto_selecionado ? 800 : 600"
      @click:primary="salvarRessuprimento"
      @click:hidden-dialog="fecharDialog"
    >
      <v-radio-group v-model="apenas_produto_selecionado">
        <v-radio :value="true">
          <template #label>
            <span class="ml-1">Aplicar apenas no produto selecionado</span>
          </template>
        </v-radio>

        <v-radio :value="false">
          <template #label>
            <span class="ml-1">Aplicar através de filtros</span>
          </template>
        </v-radio>
      </v-radio-group>

      <DivisorComLegenda v-if="!apenas_produto_selecionado" legenda="Filtros" class="mb-5" />

      <BlocoFiltrosPrincipais v-show="!apenas_produto_selecionado" :filtros="filtros" ocultar_filtro_filiais />

      <DivisorComLegenda v-if="!apenas_produto_selecionado" legenda="Parâmetros" class="mb-5 mt-2" />

      <div class="d-flex">
        <TextFieldFormatadorDeValor
          v-model="qtde_dias_tempo_forecast"
          label="Informe o tempo de previsão de gatilho"
          outlined
          inteiro
          suffix="dias"
          :error-messages="QTDE_TEMPO_FORECAST_ERROS"
          @focus="$event.target.select()"
          @keypress.enter="salvarRessuprimento()"
        />
      </div>
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from "@/components/padraoDeLayout/SysDialog";
import TextFieldFormatadorDeValor from "@/components/utils/TextFieldFormatadorDeValor";
import {required} from "vuelidate/lib/validators";
import {salvarPrevisaoGatilho} from "@/api/compraPorProdutosGerais/Produtos";
import {logout} from "@/helpers";
import BlocoFiltrosPrincipais from "@/components/compra/ProdutosGerais/Filtros/BlocoFiltrosPrincipais";
import DivisorComLegenda from "@/components/utils/DivisorComLegenda";

export default {
  name: "PrevisaoGatilho",
  components: {
    DivisorComLegenda,
    BlocoFiltrosPrincipais,
    TextFieldFormatadorDeValor,
    SysDialog
  },
  props: {
    produto: Object
  },
  data: () => ({
    dialog_ativo: false,
    apenas_produto_selecionado: true,
    qtde_dias_tempo_forecast: 0,
    filtros: {
      grupos: [],
      filiais: [],
      segmentos: [],
      secoes: [],
      categorias: [],
      linhas: [],
      compradores: [],
      fornecedores: [],
      marcas: [],
    }
  }),
  validations: {
    qtde_dias_tempo_forecast: {
      required,
      minValue: function () {
        return this.qtde_dias_tempo_forecast > 1;
      }
    }
  },
  computed: {
    QTDE_TEMPO_FORECAST_ERROS() {
      const errors = [];
      if (!this.$v.qtde_dias_tempo_forecast.$dirty) return errors;
      !this.$v.qtde_dias_tempo_forecast.required && errors.push("Campo Obrigatório.");
      !this.$v.qtde_dias_tempo_forecast.minValue && errors.push("Insira um valor inteiro.");
      return errors;
    },
    FILTROS_STORE() {
      return this.$store.getters['CompraProdutosGerais/getFiltros'];
    }
  },
  methods: {
    salvarRessuprimento() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      const parametros = {
        filtros: this.filtros,
        apenas_produto_selecionado: this.apenas_produto_selecionado,
        produto: this.produto.id_produto,
        qtde_dias_tempo_forecast: this.qtde_dias_tempo_forecast
      };

      this.$store.dispatch('loading/addRequisicao',
        salvarPrevisaoGatilho(parametros)
          .then(() => {
            this.$emit("update:previsao-gatilho", {});
            this.fecharDialog();
          })
          .catch(logout)
      );
    },
    abrirDialog() {
      this.dialog_ativo = ! this.dialog_ativo;
      this.qtde_dias_tempo_forecast = this.produto.tempo_forecast;
      this.setFiltros();
    },
    setFiltros() {
      this.filtros.grupos = this.FILTROS_STORE.grupos;
      this.filtros.segmentos = this.FILTROS_STORE.segmentos;
      this.filtros.secoes = this.FILTROS_STORE.secoes;
      this.filtros.compradores = this.FILTROS_STORE.compradores;
      this.filtros.fornecedores = this.FILTROS_STORE.fornecedores;
    },
    fecharDialog() {
      this.$v.$reset();
      this.dialog_ativo = false;
      this.apenas_produto_selecionado = true;
    }
  }
}
</script>

<style scoped>

</style>
